
export const services = {
  startingPrice: "Starting price",
  details: "Details",
  question: {
    title: "Ask a Question",
    subtitle: "Private Messages",
    description: "Ask me anything and get a personal response. Every message is read and answered by me personally."
  }
};
